import type {AnalyticsConfig, AnalyticsRuntimeAdapter} from './types';

export const isBrowserPageContext = (): boolean => {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
};

export const createBrowserRuntimeAdapter = (): AnalyticsRuntimeAdapter => ({
  mode: 'browser',
  supportsPageContext: true,
  supportsCookies: true,
  supportsViewport: true,
  getPagePath() {
    return (
      document.location.pathname +
      document.location.search +
      document.location.hash
    );
  },
  getReferrer() {
    return document.referrer;
  },
  getDomain() {
    return window.location.hostname;
  },
  getViewport() {
    return {
      height: window.innerHeight,
      width: window.innerWidth,
    };
  },
});

export const createWorkerRuntimeAdapter = (): AnalyticsRuntimeAdapter => ({
  mode: 'worker',
  supportsPageContext: false,
  supportsCookies: false,
  supportsViewport: false,
  getPagePath() {
    return null;
  },
  getReferrer() {
    return null;
  },
  getDomain() {
    return null;
  },
  getViewport() {
    return null;
  },
});

export const createRuntimeAdapter = (
  config: AnalyticsConfig,
): AnalyticsRuntimeAdapter => {
  if (config.runtimeAdapter) {
    return config.runtimeAdapter;
  }

  if (config.runtime === 'browser') {
    return createBrowserRuntimeAdapter();
  }

  if (config.runtime === 'worker') {
    return createWorkerRuntimeAdapter();
  }

  // Fallback to checking for document/window if the runtime is not set explicitly
  return isBrowserPageContext()
    ? createBrowserRuntimeAdapter()
    : createWorkerRuntimeAdapter();
};
